import { MessageCircle } from "lucide-react";

const PHONE = "393274256432"; // +39 327 425 64 32 senza spazi e +
const DEFAULT_MSG = encodeURIComponent(
  "Ciao Falco! Ho visto il tuo sito e vorrei un preventivo per un video. Puoi darmi maggiori info?"
);

export default function WhatsAppFab() {
  const href = `https://wa.me/${PHONE}?text=${DEFAULT_MSG}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contattami su WhatsApp"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white font-semibold shadow-2xl shadow-[#25D366]/30 hover:shadow-[#25D366]/50 hover:-translate-y-0.5 transition-all duration-300"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
        <MessageCircle strokeWidth={2} className="w-5 h-5 relative fill-white" />
      </span>
      <span className="hidden sm:inline text-sm">Scrivimi su WhatsApp</span>
    </a>
  );
}
